// source: textChat.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

goog.exportSymbol('proto.textChat.ButtonAction', null, global);
goog.exportSymbol('proto.textChat.ChatTranscript', null, global);
goog.exportSymbol('proto.textChat.FileChunk', null, global);
goog.exportSymbol('proto.textChat.FileUploadButton', null, global);
goog.exportSymbol('proto.textChat.InitTextChatSession', null, global);
goog.exportSymbol('proto.textChat.ToTextChatClient', null, global);
goog.exportSymbol('proto.textChat.ToTextChatClient.ContentCase', null, global);
goog.exportSymbol('proto.textChat.ToTextChatServer', null, global);
goog.exportSymbol('proto.textChat.ToTextChatServer.ContentCase', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.textChat.ToTextChatServer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.textChat.ToTextChatServer.oneofGroups_);
};
goog.inherits(proto.textChat.ToTextChatServer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.textChat.ToTextChatServer.displayName = 'proto.textChat.ToTextChatServer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.textChat.ToTextChatClient = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.textChat.ToTextChatClient.oneofGroups_);
};
goog.inherits(proto.textChat.ToTextChatClient, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.textChat.ToTextChatClient.displayName = 'proto.textChat.ToTextChatClient';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.textChat.ChatTranscript = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.textChat.ChatTranscript.repeatedFields_, null);
};
goog.inherits(proto.textChat.ChatTranscript, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.textChat.ChatTranscript.displayName = 'proto.textChat.ChatTranscript';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.textChat.FileUploadButton = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.textChat.FileUploadButton.repeatedFields_, null);
};
goog.inherits(proto.textChat.FileUploadButton, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.textChat.FileUploadButton.displayName = 'proto.textChat.FileUploadButton';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.textChat.FileChunk = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.textChat.FileChunk, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.textChat.FileChunk.displayName = 'proto.textChat.FileChunk';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.textChat.ButtonAction = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.textChat.ButtonAction, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.textChat.ButtonAction.displayName = 'proto.textChat.ButtonAction';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.textChat.InitTextChatSession = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.textChat.InitTextChatSession, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.textChat.InitTextChatSession.displayName = 'proto.textChat.InitTextChatSession';
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.textChat.ToTextChatServer.oneofGroups_ = [[1,2,3,4]];

/**
 * @enum {number}
 */
proto.textChat.ToTextChatServer.ContentCase = {
  CONTENT_NOT_SET: 0,
  USER_SUBMITTED_TEXT: 1,
  FILE_CHUNK: 2,
  BUTTON_ACTION: 3,
  INIT_SESSION: 4
};

/**
 * @return {proto.textChat.ToTextChatServer.ContentCase}
 */
proto.textChat.ToTextChatServer.prototype.getContentCase = function() {
  return /** @type {proto.textChat.ToTextChatServer.ContentCase} */(jspb.Message.computeOneofCase(this, proto.textChat.ToTextChatServer.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.textChat.ToTextChatServer.prototype.toObject = function(opt_includeInstance) {
  return proto.textChat.ToTextChatServer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.textChat.ToTextChatServer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.textChat.ToTextChatServer.toObject = function(includeInstance, msg) {
  var f, obj = {
    userSubmittedText: jspb.Message.getFieldWithDefault(msg, 1, ""),
    fileChunk: (f = msg.getFileChunk()) && proto.textChat.FileChunk.toObject(includeInstance, f),
    buttonAction: (f = msg.getButtonAction()) && proto.textChat.ButtonAction.toObject(includeInstance, f),
    initSession: (f = msg.getInitSession()) && proto.textChat.InitTextChatSession.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.textChat.ToTextChatServer}
 */
proto.textChat.ToTextChatServer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.textChat.ToTextChatServer;
  return proto.textChat.ToTextChatServer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.textChat.ToTextChatServer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.textChat.ToTextChatServer}
 */
proto.textChat.ToTextChatServer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserSubmittedText(value);
      break;
    case 2:
      var value = new proto.textChat.FileChunk;
      reader.readMessage(value,proto.textChat.FileChunk.deserializeBinaryFromReader);
      msg.setFileChunk(value);
      break;
    case 3:
      var value = new proto.textChat.ButtonAction;
      reader.readMessage(value,proto.textChat.ButtonAction.deserializeBinaryFromReader);
      msg.setButtonAction(value);
      break;
    case 4:
      var value = new proto.textChat.InitTextChatSession;
      reader.readMessage(value,proto.textChat.InitTextChatSession.deserializeBinaryFromReader);
      msg.setInitSession(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.textChat.ToTextChatServer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.textChat.ToTextChatServer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.textChat.ToTextChatServer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.textChat.ToTextChatServer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFileChunk();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.textChat.FileChunk.serializeBinaryToWriter
    );
  }
  f = message.getButtonAction();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.textChat.ButtonAction.serializeBinaryToWriter
    );
  }
  f = message.getInitSession();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.textChat.InitTextChatSession.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_submitted_text = 1;
 * @return {string}
 */
proto.textChat.ToTextChatServer.prototype.getUserSubmittedText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.textChat.ToTextChatServer} returns this
 */
proto.textChat.ToTextChatServer.prototype.setUserSubmittedText = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.textChat.ToTextChatServer.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.textChat.ToTextChatServer} returns this
 */
proto.textChat.ToTextChatServer.prototype.clearUserSubmittedText = function() {
  return jspb.Message.setOneofField(this, 1, proto.textChat.ToTextChatServer.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.textChat.ToTextChatServer.prototype.hasUserSubmittedText = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional FileChunk file_chunk = 2;
 * @return {?proto.textChat.FileChunk}
 */
proto.textChat.ToTextChatServer.prototype.getFileChunk = function() {
  return /** @type{?proto.textChat.FileChunk} */ (
    jspb.Message.getWrapperField(this, proto.textChat.FileChunk, 2));
};


/**
 * @param {?proto.textChat.FileChunk|undefined} value
 * @return {!proto.textChat.ToTextChatServer} returns this
*/
proto.textChat.ToTextChatServer.prototype.setFileChunk = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.textChat.ToTextChatServer.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.textChat.ToTextChatServer} returns this
 */
proto.textChat.ToTextChatServer.prototype.clearFileChunk = function() {
  return this.setFileChunk(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.textChat.ToTextChatServer.prototype.hasFileChunk = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ButtonAction button_action = 3;
 * @return {?proto.textChat.ButtonAction}
 */
proto.textChat.ToTextChatServer.prototype.getButtonAction = function() {
  return /** @type{?proto.textChat.ButtonAction} */ (
    jspb.Message.getWrapperField(this, proto.textChat.ButtonAction, 3));
};


/**
 * @param {?proto.textChat.ButtonAction|undefined} value
 * @return {!proto.textChat.ToTextChatServer} returns this
*/
proto.textChat.ToTextChatServer.prototype.setButtonAction = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.textChat.ToTextChatServer.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.textChat.ToTextChatServer} returns this
 */
proto.textChat.ToTextChatServer.prototype.clearButtonAction = function() {
  return this.setButtonAction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.textChat.ToTextChatServer.prototype.hasButtonAction = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional InitTextChatSession init_session = 4;
 * @return {?proto.textChat.InitTextChatSession}
 */
proto.textChat.ToTextChatServer.prototype.getInitSession = function() {
  return /** @type{?proto.textChat.InitTextChatSession} */ (
    jspb.Message.getWrapperField(this, proto.textChat.InitTextChatSession, 4));
};


/**
 * @param {?proto.textChat.InitTextChatSession|undefined} value
 * @return {!proto.textChat.ToTextChatServer} returns this
*/
proto.textChat.ToTextChatServer.prototype.setInitSession = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.textChat.ToTextChatServer.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.textChat.ToTextChatServer} returns this
 */
proto.textChat.ToTextChatServer.prototype.clearInitSession = function() {
  return this.setInitSession(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.textChat.ToTextChatServer.prototype.hasInitSession = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.textChat.ToTextChatClient.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.textChat.ToTextChatClient.ContentCase = {
  CONTENT_NOT_SET: 0,
  CHAT_TRANSCRIPT: 1,
  STATIC_FILE_UPLOAD_BUTTON: 2
};

/**
 * @return {proto.textChat.ToTextChatClient.ContentCase}
 */
proto.textChat.ToTextChatClient.prototype.getContentCase = function() {
  return /** @type {proto.textChat.ToTextChatClient.ContentCase} */(jspb.Message.computeOneofCase(this, proto.textChat.ToTextChatClient.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.textChat.ToTextChatClient.prototype.toObject = function(opt_includeInstance) {
  return proto.textChat.ToTextChatClient.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.textChat.ToTextChatClient} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.textChat.ToTextChatClient.toObject = function(includeInstance, msg) {
  var f, obj = {
    chatTranscript: (f = msg.getChatTranscript()) && proto.textChat.ChatTranscript.toObject(includeInstance, f),
    staticFileUploadButton: (f = msg.getStaticFileUploadButton()) && proto.textChat.FileUploadButton.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.textChat.ToTextChatClient}
 */
proto.textChat.ToTextChatClient.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.textChat.ToTextChatClient;
  return proto.textChat.ToTextChatClient.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.textChat.ToTextChatClient} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.textChat.ToTextChatClient}
 */
proto.textChat.ToTextChatClient.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.textChat.ChatTranscript;
      reader.readMessage(value,proto.textChat.ChatTranscript.deserializeBinaryFromReader);
      msg.setChatTranscript(value);
      break;
    case 2:
      var value = new proto.textChat.FileUploadButton;
      reader.readMessage(value,proto.textChat.FileUploadButton.deserializeBinaryFromReader);
      msg.setStaticFileUploadButton(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.textChat.ToTextChatClient.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.textChat.ToTextChatClient.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.textChat.ToTextChatClient} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.textChat.ToTextChatClient.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChatTranscript();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.textChat.ChatTranscript.serializeBinaryToWriter
    );
  }
  f = message.getStaticFileUploadButton();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.textChat.FileUploadButton.serializeBinaryToWriter
    );
  }
};


/**
 * optional ChatTranscript chat_transcript = 1;
 * @return {?proto.textChat.ChatTranscript}
 */
proto.textChat.ToTextChatClient.prototype.getChatTranscript = function() {
  return /** @type{?proto.textChat.ChatTranscript} */ (
    jspb.Message.getWrapperField(this, proto.textChat.ChatTranscript, 1));
};


/**
 * @param {?proto.textChat.ChatTranscript|undefined} value
 * @return {!proto.textChat.ToTextChatClient} returns this
*/
proto.textChat.ToTextChatClient.prototype.setChatTranscript = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.textChat.ToTextChatClient.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.textChat.ToTextChatClient} returns this
 */
proto.textChat.ToTextChatClient.prototype.clearChatTranscript = function() {
  return this.setChatTranscript(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.textChat.ToTextChatClient.prototype.hasChatTranscript = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional FileUploadButton static_file_upload_button = 2;
 * @return {?proto.textChat.FileUploadButton}
 */
proto.textChat.ToTextChatClient.prototype.getStaticFileUploadButton = function() {
  return /** @type{?proto.textChat.FileUploadButton} */ (
    jspb.Message.getWrapperField(this, proto.textChat.FileUploadButton, 2));
};


/**
 * @param {?proto.textChat.FileUploadButton|undefined} value
 * @return {!proto.textChat.ToTextChatClient} returns this
*/
proto.textChat.ToTextChatClient.prototype.setStaticFileUploadButton = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.textChat.ToTextChatClient.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.textChat.ToTextChatClient} returns this
 */
proto.textChat.ToTextChatClient.prototype.clearStaticFileUploadButton = function() {
  return this.setStaticFileUploadButton(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.textChat.ToTextChatClient.prototype.hasStaticFileUploadButton = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.textChat.ChatTranscript.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.textChat.ChatTranscript.prototype.toObject = function(opt_includeInstance) {
  return proto.textChat.ChatTranscript.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.textChat.ChatTranscript} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.textChat.ChatTranscript.toObject = function(includeInstance, msg) {
  var f, obj = {
    source: jspb.Message.getFieldWithDefault(msg, 1, ""),
    message: jspb.Message.getFieldWithDefault(msg, 2, ""),
    itemId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    fileUploadButtonsList: jspb.Message.toObjectList(msg.getFileUploadButtonsList(),
    proto.textChat.FileUploadButton.toObject, includeInstance),
    msgIncomplete: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.textChat.ChatTranscript}
 */
proto.textChat.ChatTranscript.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.textChat.ChatTranscript;
  return proto.textChat.ChatTranscript.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.textChat.ChatTranscript} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.textChat.ChatTranscript}
 */
proto.textChat.ChatTranscript.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSource(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemId(value);
      break;
    case 4:
      var value = new proto.textChat.FileUploadButton;
      reader.readMessage(value,proto.textChat.FileUploadButton.deserializeBinaryFromReader);
      msg.addFileUploadButtons(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMsgIncomplete(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.textChat.ChatTranscript.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.textChat.ChatTranscript.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.textChat.ChatTranscript} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.textChat.ChatTranscript.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSource();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getItemId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFileUploadButtonsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.textChat.FileUploadButton.serializeBinaryToWriter
    );
  }
  f = message.getMsgIncomplete();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional string source = 1;
 * @return {string}
 */
proto.textChat.ChatTranscript.prototype.getSource = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.textChat.ChatTranscript} returns this
 */
proto.textChat.ChatTranscript.prototype.setSource = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.textChat.ChatTranscript.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.textChat.ChatTranscript} returns this
 */
proto.textChat.ChatTranscript.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string item_id = 3;
 * @return {string}
 */
proto.textChat.ChatTranscript.prototype.getItemId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.textChat.ChatTranscript} returns this
 */
proto.textChat.ChatTranscript.prototype.setItemId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated FileUploadButton file_upload_buttons = 4;
 * @return {!Array<!proto.textChat.FileUploadButton>}
 */
proto.textChat.ChatTranscript.prototype.getFileUploadButtonsList = function() {
  return /** @type{!Array<!proto.textChat.FileUploadButton>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.textChat.FileUploadButton, 4));
};


/**
 * @param {!Array<!proto.textChat.FileUploadButton>} value
 * @return {!proto.textChat.ChatTranscript} returns this
*/
proto.textChat.ChatTranscript.prototype.setFileUploadButtonsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.textChat.FileUploadButton=} opt_value
 * @param {number=} opt_index
 * @return {!proto.textChat.FileUploadButton}
 */
proto.textChat.ChatTranscript.prototype.addFileUploadButtons = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.textChat.FileUploadButton, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.textChat.ChatTranscript} returns this
 */
proto.textChat.ChatTranscript.prototype.clearFileUploadButtonsList = function() {
  return this.setFileUploadButtonsList([]);
};


/**
 * optional bool msg_incomplete = 5;
 * @return {boolean}
 */
proto.textChat.ChatTranscript.prototype.getMsgIncomplete = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.textChat.ChatTranscript} returns this
 */
proto.textChat.ChatTranscript.prototype.setMsgIncomplete = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.textChat.FileUploadButton.repeatedFields_ = [9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.textChat.FileUploadButton.prototype.toObject = function(opt_includeInstance) {
  return proto.textChat.FileUploadButton.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.textChat.FileUploadButton} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.textChat.FileUploadButton.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    text: jspb.Message.getFieldWithDefault(msg, 2, ""),
    action: jspb.Message.getFieldWithDefault(msg, 3, ""),
    visible: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    highlight: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    backgroundColor: jspb.Message.getFieldWithDefault(msg, 6, ""),
    textColor: jspb.Message.getFieldWithDefault(msg, 7, ""),
    borderColor: jspb.Message.getFieldWithDefault(msg, 8, ""),
    availableDocTypesList: (f = jspb.Message.getRepeatedField(msg, 9)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.textChat.FileUploadButton}
 */
proto.textChat.FileUploadButton.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.textChat.FileUploadButton;
  return proto.textChat.FileUploadButton.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.textChat.FileUploadButton} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.textChat.FileUploadButton}
 */
proto.textChat.FileUploadButton.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAction(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVisible(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHighlight(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setBackgroundColor(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setTextColor(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setBorderColor(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.addAvailableDocTypes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.textChat.FileUploadButton.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.textChat.FileUploadButton.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.textChat.FileUploadButton} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.textChat.FileUploadButton.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAction();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getVisible();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getHighlight();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getBackgroundColor();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getTextColor();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getBorderColor();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getAvailableDocTypesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      9,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.textChat.FileUploadButton.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.textChat.FileUploadButton} returns this
 */
proto.textChat.FileUploadButton.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string text = 2;
 * @return {string}
 */
proto.textChat.FileUploadButton.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.textChat.FileUploadButton} returns this
 */
proto.textChat.FileUploadButton.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string action = 3;
 * @return {string}
 */
proto.textChat.FileUploadButton.prototype.getAction = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.textChat.FileUploadButton} returns this
 */
proto.textChat.FileUploadButton.prototype.setAction = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool visible = 4;
 * @return {boolean}
 */
proto.textChat.FileUploadButton.prototype.getVisible = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.textChat.FileUploadButton} returns this
 */
proto.textChat.FileUploadButton.prototype.setVisible = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool highlight = 5;
 * @return {boolean}
 */
proto.textChat.FileUploadButton.prototype.getHighlight = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.textChat.FileUploadButton} returns this
 */
proto.textChat.FileUploadButton.prototype.setHighlight = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional string background_color = 6;
 * @return {string}
 */
proto.textChat.FileUploadButton.prototype.getBackgroundColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.textChat.FileUploadButton} returns this
 */
proto.textChat.FileUploadButton.prototype.setBackgroundColor = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string text_color = 7;
 * @return {string}
 */
proto.textChat.FileUploadButton.prototype.getTextColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.textChat.FileUploadButton} returns this
 */
proto.textChat.FileUploadButton.prototype.setTextColor = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string border_color = 8;
 * @return {string}
 */
proto.textChat.FileUploadButton.prototype.getBorderColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.textChat.FileUploadButton} returns this
 */
proto.textChat.FileUploadButton.prototype.setBorderColor = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * repeated string available_doc_types = 9;
 * @return {!Array<string>}
 */
proto.textChat.FileUploadButton.prototype.getAvailableDocTypesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 9));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.textChat.FileUploadButton} returns this
 */
proto.textChat.FileUploadButton.prototype.setAvailableDocTypesList = function(value) {
  return jspb.Message.setField(this, 9, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.textChat.FileUploadButton} returns this
 */
proto.textChat.FileUploadButton.prototype.addAvailableDocTypes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 9, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.textChat.FileUploadButton} returns this
 */
proto.textChat.FileUploadButton.prototype.clearAvailableDocTypesList = function() {
  return this.setAvailableDocTypesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.textChat.FileChunk.prototype.toObject = function(opt_includeInstance) {
  return proto.textChat.FileChunk.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.textChat.FileChunk} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.textChat.FileChunk.toObject = function(includeInstance, msg) {
  var f, obj = {
    transferId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    chunkData: msg.getChunkData_asB64(),
    isLastChunk: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    fileName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    fileSize: jspb.Message.getFieldWithDefault(msg, 5, 0),
    contentMimeType: jspb.Message.getFieldWithDefault(msg, 6, ""),
    docType: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.textChat.FileChunk}
 */
proto.textChat.FileChunk.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.textChat.FileChunk;
  return proto.textChat.FileChunk.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.textChat.FileChunk} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.textChat.FileChunk}
 */
proto.textChat.FileChunk.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransferId(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setChunkData(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsLastChunk(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileName(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setFileSize(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setContentMimeType(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.textChat.FileChunk.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.textChat.FileChunk.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.textChat.FileChunk} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.textChat.FileChunk.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTransferId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getChunkData_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
  f = message.getIsLastChunk();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getFileName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getFileSize();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getContentMimeType();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getDocType();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string transfer_id = 1;
 * @return {string}
 */
proto.textChat.FileChunk.prototype.getTransferId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.textChat.FileChunk} returns this
 */
proto.textChat.FileChunk.prototype.setTransferId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bytes chunk_data = 2;
 * @return {!(string|Uint8Array)}
 */
proto.textChat.FileChunk.prototype.getChunkData = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes chunk_data = 2;
 * This is a type-conversion wrapper around `getChunkData()`
 * @return {string}
 */
proto.textChat.FileChunk.prototype.getChunkData_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getChunkData()));
};


/**
 * optional bytes chunk_data = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getChunkData()`
 * @return {!Uint8Array}
 */
proto.textChat.FileChunk.prototype.getChunkData_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getChunkData()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.textChat.FileChunk} returns this
 */
proto.textChat.FileChunk.prototype.setChunkData = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};


/**
 * optional bool is_last_chunk = 3;
 * @return {boolean}
 */
proto.textChat.FileChunk.prototype.getIsLastChunk = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.textChat.FileChunk} returns this
 */
proto.textChat.FileChunk.prototype.setIsLastChunk = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional string file_name = 4;
 * @return {string}
 */
proto.textChat.FileChunk.prototype.getFileName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.textChat.FileChunk} returns this
 */
proto.textChat.FileChunk.prototype.setFileName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional uint32 file_size = 5;
 * @return {number}
 */
proto.textChat.FileChunk.prototype.getFileSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.textChat.FileChunk} returns this
 */
proto.textChat.FileChunk.prototype.setFileSize = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string content_mime_type = 6;
 * @return {string}
 */
proto.textChat.FileChunk.prototype.getContentMimeType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.textChat.FileChunk} returns this
 */
proto.textChat.FileChunk.prototype.setContentMimeType = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string doc_type = 7;
 * @return {string}
 */
proto.textChat.FileChunk.prototype.getDocType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.textChat.FileChunk} returns this
 */
proto.textChat.FileChunk.prototype.setDocType = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.textChat.ButtonAction.prototype.toObject = function(opt_includeInstance) {
  return proto.textChat.ButtonAction.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.textChat.ButtonAction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.textChat.ButtonAction.toObject = function(includeInstance, msg) {
  var f, obj = {
    buttonId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    action: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.textChat.ButtonAction}
 */
proto.textChat.ButtonAction.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.textChat.ButtonAction;
  return proto.textChat.ButtonAction.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.textChat.ButtonAction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.textChat.ButtonAction}
 */
proto.textChat.ButtonAction.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setButtonId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAction(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.textChat.ButtonAction.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.textChat.ButtonAction.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.textChat.ButtonAction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.textChat.ButtonAction.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getButtonId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAction();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string button_id = 1;
 * @return {string}
 */
proto.textChat.ButtonAction.prototype.getButtonId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.textChat.ButtonAction} returns this
 */
proto.textChat.ButtonAction.prototype.setButtonId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string action = 2;
 * @return {string}
 */
proto.textChat.ButtonAction.prototype.getAction = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.textChat.ButtonAction} returns this
 */
proto.textChat.ButtonAction.prototype.setAction = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.textChat.InitTextChatSession.prototype.toObject = function(opt_includeInstance) {
  return proto.textChat.InitTextChatSession.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.textChat.InitTextChatSession} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.textChat.InitTextChatSession.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.textChat.InitTextChatSession}
 */
proto.textChat.InitTextChatSession.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.textChat.InitTextChatSession;
  return proto.textChat.InitTextChatSession.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.textChat.InitTextChatSession} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.textChat.InitTextChatSession}
 */
proto.textChat.InitTextChatSession.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.textChat.InitTextChatSession.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.textChat.InitTextChatSession.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.textChat.InitTextChatSession} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.textChat.InitTextChatSession.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


goog.object.extend(exports, proto.textChat);
